module.exports = __webpack_public_path__ + "static/media/forbidden.a9786723.png";